var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBackground32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6187 7.61872C16.9604 7.27701 16.9604 6.72299 16.6187 6.38128L11.0503 0.812816C10.7085 0.471107 10.1545 0.471107 9.81282 0.812816C9.47111 1.15452 9.47111 1.70854 9.81282 2.05025L14.7626 7L9.81282 11.9497C9.47111 12.2915 9.47111 12.8455 9.81282 13.1872C10.1545 13.5289 10.7085 13.5289 11.0503 13.1872L16.6187 7.61872ZM0 7.875H16V6.125H0V7.875Z",
    fill: "#21244B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBackground32);
export default __webpack_public_path__ + "static/media/arrow-right-background3_2.64fe52ee4b62b3b0ca46321e704c09e3.svg";
export { ForwardRef as ReactComponent };